import React from 'react';
import { Link } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const menuItems = [
    { title: 'Theme Settings', path: '/admin/theme', description: 'Customize colors and appearance' },
    { title: 'Home Page', path: '/admin/pages/home', description: 'Edit home page content' },
    { title: 'About Page', path: '/admin/pages/about', description: 'Edit about page content' },
    { title: 'Success Stories', path: '/admin/success-stories', description: 'Manage success stories' },
    { title: 'Clients & Services', path: '/admin/clients-services', description: 'Manage clients and services' },
    { title: 'Blog Posts', path: '/admin/blog', description: 'Create and manage blog posts' },
    { title: 'Media Library', path: '/admin/media', description: 'Upload and manage images' },
    { title: 'Contact Submissions', path: '/admin/contact-submissions', description: 'View contact form submissions' },
    { title: 'Footer Settings', path: '/admin/footer', description: 'Edit footer content' },
  ];

  return (
    <div className="admin-dashboard">
      <div className="container">
        <h1>Admin Dashboard</h1>
        <p>Welcome to your content management system. Select an option below to get started.</p>

        <div className="dashboard-grid">
          {menuItems.map((item, index) => (
            <Link key={index} to={item.path} className="dashboard-card">
              <h3>{item.title}</h3>
              <p>{item.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
